import styled from 'styled-components';
import iconbutton from '../../assets/svg/sprites.svg';

export const SectionVideoCard = styled.div`
  padding: 50px 0 0;
  overflow: hidden;
  background: #${({ backgroundColor }) => backgroundColor};

  &.project-list {
    .project_videolist,
    .zeropadding_responsive {
      @media (max-width: 767.98px) {
        padding: 0;
      }
    }

    .card_list {
      @media (min-width: 1101px) {
        margin-left: -15px;
        margin-right: -15px;
      }

      @media (max-width: 1099px) {
        margin-left: 25px;
        margin-right: 25px;
      }

      @media (max-width: 991.98px) {
        margin-left: 15px;
        margin-right: 15px;
      }

      @media (max-width: 767.98px) {
        margin-right: 0;
        margin-left: 0;
      }
    }

    &:nth-of-type(even) {
      padding-bottom: 50px;
    }

    .card_slidercap {
      display: flex;
      flex-direction: column-reverse;
      padding: ${({ dir }) => (dir === 'rtl' ? '1.5rem 1rem 1.5rem 1.5rem' : '')};
      width: ${({ dir }) => (dir === 'rtl' ? '275px' : '')};
      @media (max-width: 575.98px) {
        padding: ${({ dir }) => (dir === 'rtl' ? '1rem' : '')};
      }

      p {
        font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
        line-height: 16px;
      }
      h3 {
        text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
      }
    }

    &[dir='ltr'] {
      .card_slidercap {
        p {
          letter-spacing: 1.29px;
        }
      }
    }
  }
`;

export const SectionCaption = styled.div`
  position: relative;
  text-align: center;

  @media (max-width: 991.98px) {
    padding: 0 30px;
  }

  h2 {
    color: #4a4a4a;

    @media (max-width: 767.98px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: ${({ dir }) => (dir === 'rtl' ? '1.5rem' : '1rem')};
    }
  }

  p {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;

    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight, sans-serif;
      line-height: 28px;
      font-size: 18px;
    }

    &[dir='ltr'] {
      font-family: 'DINRegular';
      letter-spacing: 1.29px;
      font-size: 16px;
      line-height: 20px;
    }
    color: #4a4a4a;
    margin-bottom: 1.5rem;

    @media (max-width: 991.98px) {
      color: #898989;
      font-size: ${({ dir }) => (dir === 'rtl' ? '14px!important' : '13px!important')};
    }
  }
`;

export const VideoPart = styled.div`
  position: relative;
  padding: 0;
`;

export const VideoImg = styled.div`
  position: relative;
  height: 670px;
  overflow: hidden;

  .lazy-load-image-background {
    display: block !important;
    height: 100%;
  }

  @media (min-width: 1200px) and (max-width: 1279.98px) {
    height: 605px;
  }

  @media (max-width: 1199.98px) {
    height: 400px;
  }

  @media (max-width: 991.98px) {
    height: 300px;
  }
  @media (max-width: 575px) {
    height: 223px;
  }
  @media (max-width: 375px) {
    height: auto;
  }

  &.video_img {
    img {
      position: absolute;
      width: 100%;
      height: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      @media (max-width: 1199.98px) {
        width: auto;
        height: 100%;
      }
    }
  }
`;

export const VideoContainer = styled.div`
  &:hover {
    div[class*='VideoTextCardstyled__VideoButton-'] {
      display: block !important;
    }
  }

  iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    user-select: none;
    width: 100%;

    .player {
      .vp-controls {
        opacity: 0 !important;
      }
    }
  }

  .video-react-control-bar {
    display: none;
  }

  .video-react {
    .video-react-big-play-button {
      border: 6px solid #fff !important;
      background: none !important;
      padding: 38.5px !important;
      border-radius: 50%;
      width: auto;

      @media (max-width: 1199.98px) {
        margin-top: -3.5em;
      }

      @media (max-width: 991.98px) {
        margin-left: -0.75em;
        margin-top: -2.75em;
      }

      @media (max-width: 767.98px) {
        padding: 25.5px !important;
        margin-left: -1em;
        margin-top: -0.75em;
        border: 4px solid #fff !important;
      }

      &:before {
        top: 18px;

        @media (max-width: 767.98px) {
          top: 4px;
        }
      }
    }

    .video-react-bezel {
      display: none !important;
    }
  }

  .video-react-paused {
    .video-react-big-play-button {
      display: block !important;
      transition: 0.5s;
    }
  }
`;

export const VideoButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  cursor: pointer;

  &:after {
    content: '';
    display: inline-block;
    background: url(${iconbutton}#playic) no-repeat;
    width: 93px;
    height: 94px;
    margin: 0 auto;
  }

  &.show {
    display: block;
  }

  &.hide {
    display: none;
  }
`;
